// import axios from "axios";

// // Create instance
// const api = axios.create({
//   baseURL: process.env.REACT_APP_BASE_API_URL,
// });

// // Helper to redirect to login
// // const redirectToLogin = () => {
// //   localStorage.setItem("token", null);
// //   localStorage.setItem("login", null);
// //   localStorage.setItem("user", null);
// //   //window.location.href = "/login"; // adjust for your routing

// //   // Hard redirect (SAFE outside React)
// //   window.location.replace("/login");
// // };

// // Function to set headers dynamically
// const setHeaders = () => {
//   const token = localStorage.getItem("token");
//   console.log("Sending Token ::: " + token);
//   return {
//     Authorization: `Bearer ${token}`,
//     Role: "OPERATOR",
//     "Content-Type": "application/json",
//   };
// };

// const setHeadersmultyform = () => {
//   const token = localStorage.getItem("token");
//   console.log("Sending Token ::: " + token);
//   return {
//     Authorization: `Bearer ${token}`,
//     Role: "OPERATOR",
//     "Content-Type": "multipart/form-data",
//   };
// };

// // === INTERCEPTORS ===
// // Add headers before each request
// api.interceptors.request.use(
//   (config) => {
//     const token = localStorage.getItem("token");
//     if (token) {
//       config.headers.Authorization = `Bearer ${token}`;
//       config.headers.Role = "OPERATOR";
//     }
//     return config;
//   },
//   (error) => Promise.reject(error)
// );

// // Handle all responses globally
// api.interceptors.response.use(
//   (response) => response,
//   (error) => {
//     console.log("API Error::"+error)
//     if (error.response) {
//       const status = error.response.status;

//       if (status === 401) {
//         console.warn("Unauthorized! Redirecting...");
//         const currentPath = window.location.pathname;
//         // ❌ Do NOT redirect if already on home
//         if (currentPath !== "/" && currentPath !== "/home") {
//           localStorage.clear();
//           window.location.replace("/login");
//         }
//       } else {
//         console.error("API Error:", error.response);
//       }
//     } else if (error.request) {
//       console.warn("No response received:", error.request);
//     } else {
//       console.warn("Request setup error:", error.message);
//     }
//     return Promise.reject(error);
//   }
// );

// // === API METHODS ===
// export async function get(url, data = {}) {
//   const resp = await api.get(url, data);
//   return resp.data;
// }

// export async function post(url, data) {
//   const resp = await api.post(url, data);
//   return resp.data;
// }

// export async function put(url, data) {
//   const resp = await api.put(url, data);
//   return resp.data;
// }

// export async function multy_post(url, data) {
//   const resp = await api.post(url, data, { headers: setHeadersmultyform() });
//   return resp.data;
// }

// export async function multy_put(url, data) {
//   const resp = await api.put(url, data, { headers: setHeadersmultyform() });
//   return resp.data;
// }

// export async function deleteEntry(url) {
//   const resp = await api.delete(url);
//   return resp.data;
// }



// // Add to httpClient.service.ts or your API service file

// // Add the new function for checking package mappings (JavaScript version)
// export const checkChannelPackageMappings = async (vendorId, channelId) => {
//   try {
//     const response = await get(`${API_URL}/channel/vendor/${vendorId}/check-package-mappings?channelId=${channelId}`);
//     return response;
//   } catch (error) {
//     console.error('Error checking package mappings:', error);
//     throw error;
//   }
// };

// export default api;


// httpClient.service.js

import axios from "axios";

// Create instance
const api = axios.create({
  baseURL: process.env.REACT_APP_BASE_API_URL,
});


const API_URL = process.env.REACT_APP_BASE_API_URL;

// Function to set headers dynamically
const setHeaders = () => {
  const token = localStorage.getItem("token");
  console.log("Sending Token ::: " + token);
  return {
    Authorization: `Bearer ${token}`,
    Role: "OPERATOR",
    "Content-Type": "application/json",
  };
};

const setHeadersmultyform = () => {
  const token = localStorage.getItem("token");
  //console.log("Sending Token ::: " + token);
  return {
    Authorization: `Bearer ${token}`,
    Role: "OPERATOR",
    "Content-Type": "multipart/form-data",
  };
};

// === INTERCEPTORS ===
// Add headers before each request
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
      config.headers.Role = "OPERATOR";
    }
    return config;
  },
  (error) => Promise.reject(error)
);

api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.clear();

      setTimeout(() => {
        window.location.href = "/login";
      }, 100);

      return new Promise(() => {}); // stop propagation
    }

    return Promise.reject(error);
  }
);
/*
// Handle all responses globally
api.interceptors.response.use(
  (response) => response,
  (error) => {
    //console.log("API Error:" + error);
    if (error.response) {
      const status = error.response.status;

      if (status === 401) {
        //console.warn("Unauthorized! Redirecting...");
        const currentPath = window.location.pathname;
        // ❌ Do NOT redirect if already on home
        if (currentPath !== "/" && currentPath !== "/home") {
          localStorage.clear();
          window.location.assign("/login");
        }
      } else {
        //console.error("API Error:", error.response);
      }
    } else if (error.request) {
      //console.warn("No response received:", error.request);
    } else {
      //console.warn("Request setup error:", error.message);
    }
    return Promise.reject(error);
  }
);
*/

// === API METHODS ===
export async function get(url, data = {}) {
  const resp = await api.get(url, data);
  return resp.data;
}

export async function post(url, data) {
  const resp = await api.post(url, data);
  return resp.data;
}

export async function put(url, data) {
  const resp = await api.put(url, data);
  return resp.data;
}

export async function multy_post(url, data) {
  const resp = await api.post(url, data, { headers: setHeadersmultyform() });
  return resp.data;
}

export async function multy_put(url, data) {
  const resp = await api.put(url, data, { headers: setHeadersmultyform() });
  return resp.data;
}

export async function deleteEntry(url) {
  const resp = await api.delete(url);
  return resp.data;
}

// ✅ CORRECTED: Use relative URL (baseURL is already configured)
export const checkChannelPackageMappings = async (vendorId, channelId) => {
  try {
    const response = await get(`${API_URL}/channel/vendor/${vendorId}/check-package-mappings?channelId=${channelId}`);
    return response;
  } catch (error) {
    //console.error('Error checking package mappings:', error);
    throw error;
  }
};

export default api;